import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'

export const fetchScan = async (scanId: number): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/scan/${scanId}`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const updateScan = async (
  scanId: number,
  data: any
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.put(`/scan/${scanId}`, data)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const createScan = async (data): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`/scan`, data)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const fetchPowerEditData = async (
  scanId: number
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/scan/${scanId}/delta`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const updatePowerEditScan = async (
  scanId: number,
  cvHtml: string
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`/scan/${scanId}/poweredit`, {
      cv: cvHtml,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const latestScan = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`latestscan`)
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const powerEdit = async (data: any): Promise<ApiResponse> => {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]: any) => {
    if (value) formData.append(key, value)
  })
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post(`opportunities/poweredit`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    resp.data = response.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
